import { cn } from '#app/utils/misc'

type CourseCardShellProps = {
	media?: React.ReactNode
	badges?: React.ReactNode
	title: React.ReactNode
	description?: React.ReactNode
	footer?: React.ReactNode
	className?: string
}

export function CourseCardShell({
	media,
	badges,
	title,
	description,
	footer,
	className,
}: CourseCardShellProps) {
	return (
		<article
			className={cn(
				'group bg-card flex flex-col overflow-hidden rounded-lg border transition-all hover:shadow-lg',
				className,
			)}
		>
			{media ? (
				<div className="relative aspect-video w-full overflow-hidden">
					{media}
				</div>
			) : null}

			<div className="flex flex-1 flex-col p-4">
				{badges ? (
					<div className="flex flex-wrap items-center gap-2">{badges}</div>
				) : null}

				<div className={cn(badges ? 'mt-3' : undefined)}>{title}</div>

				{description ? (
					<p className="text-muted-foreground mt-2 line-clamp-2 text-sm">
						{description}
					</p>
				) : null}

				{footer ? <div className="mt-auto pt-4">{footer}</div> : null}
			</div>
		</article>
	)
}
